import React from "react";
import { useColors } from "../contexts/ColorContext";

function AboutUs() {
  const { getClasses } = useColors();

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <div className="relative">
              <div className="w-full h-64 md:h-96 rounded-lg relative z-10 overflow-hidden">
                <img
                  src="/imagen1.jpg"
                  alt="Jambops Solutions"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="md:w-1/2 md:pl-12">
            <h2
              className={`text-3xl font-bold ${getClasses("secondary-text")} mb-6`}
            >
              Sobre Nosotros
            </h2>

            <div className="mb-8">
              <h3
                className={`text-xl font-semibold ${getClasses("primary-text")} mb-3`}
              >
                Nuestra Misión
              </h3>
              <p className="text-gray-600">
                En Jambops Solutions, nuestra misión es proporcionar soluciones
                técnicas de la más alta calidad, combinando nuestra experiencia
                en electricidad y desarrollo web para ofrecer un servicio
                integral que satisfaga las necesidades de nuestros clientes. Nos
                comprometemos a la excelencia en cada proyecto, grande o
                pequeño.
              </p>
            </div>

            <div className="mb-8">
              <h3
                className={`text-xl font-semibold ${getClasses("primary-text")} mb-3`}
              >
                Nuestros Valores
              </h3>
              <ul className="text-gray-600 list-disc pl-5 space-y-2">
                <li>Excelencia en cada detalle de nuestro trabajo</li>
                <li>Compromiso con la satisfacción del cliente</li>
                <li>Innovación constante en nuestras soluciones</li>
                <li>Ética profesional y transparencia</li>
                <li>Responsabilidad en todos nuestros servicios</li>
              </ul>
            </div>

            <div>
              <h3
                className={`text-xl font-semibold ${getClasses("primary-text")} mb-3`}
              >
                ¿Por Qué Elegirnos?
              </h3>
              <p className="text-gray-600">
                Nuestra combinación única de experiencia en instalaciones
                eléctricas y desarrollo web nos permite ofrecer soluciones
                integrales que pocos competidores pueden igualar. Entendemos
                tanto el mundo físico como el digital, y cómo conectarlos para
                el éxito de su negocio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
